module.exports = __webpack_public_path__ + "static/media/banner_m_03.a885a763.jpg";